module.exports = __webpack_public_path__ + "img/1553264965.488db259.jpg";